// extracted by mini-css-extract-plugin
export default {"loader":"LoadingDots__loader___If_QL","loadingDot":"LoadingDots__loadingDot___eebMY","blink":"LoadingDots__blink___csQyc"};